import * as React from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import { getURLPath } from "../../helpers/Tools";
import Spinner from '../common/spinner';
import { SET_MARKETING_EMAIL_OPT_IN } from "../../constants/actionTypes";

class MarketingEmailOptIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = { optIn: null };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.MarketingEmailOptIn.ComponentDidMount", new Date(), getURLPath);
    }

    handleClick = (event, optInBool) => {
        this.setState({ preferencesChanging: true })
        const { email, firstName, lastName, setMarketingEmailOptIn } = this.props;

        try {
            logUI(`MBHWeb.UI.MarketingEmailOptIn.OptIn${optInBool}`, new Date(), getURLPath());
            const optInData = [{
                email,
                firstName,
                lastName,
                emailOptInValue: optInBool
            }]
            setMarketingEmailOptIn(optInData)
            this.setState({ optIn: optInBool })
        }
        catch (e) {
            console.log('err', e)
        }
    }

    handleLeavePage = () => {
        const { showInsuranceForm, exitToPath, reDirectUrl} = this.props;
        try {
            if (showInsuranceForm || reDirectUrl === '/onboarding/captureinsurance') {
                logUI("MBHWeb.UI.EmailOptIn.LoadCaptureInsurance", new Date(), getURLPath());
                this.props.history.push("/onboarding/captureinsurance");
            } else if (exitToPath) {
                //debugger;
                this.props.history.push(exitToPath);
            } else {
                //debugger;
                this.props.history.push("/");
            }
        }
        catch (e) {
            console.log(e)
            //debugger;
            window.location.href = "/";
        }
    }

    render() {
        const { marketingEmailOptIn } = this.props;
        const promptOptIn = <>
            {marketingEmailOptIn.waiting && <Spinner />}
            <div className="col-12">
                <div className="row">
                    <div className="col-12 text-center maxWidth-content">
                        At Baylor Scott & White, we are always working on new ways to help improve your well-being.
                                    <h1 className="page-heading">Would you like to receive emails with information about our programs and services that may be of interest to you?</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center maxWidth-content">
                        <a className="btn btn-primary" href="#" onClick={(e) => this.handleClick(e, true)}>YES, SIGN ME UP</a>
                    </div></div>
                <div className="row">
                    <div className="col-12 text-center maxWidth-content">
                        <a className="" href="#" onClick={(e) => this.handleClick(e, false)}>No Thanks</a>
                    </div>
                </div>
            </div>
        </>
        const successOptIn = <div className="col-12">
            <div className="row">
                <div className="col-12 text-center maxWidth-content">
                    <h1 className="page-heading">Great! We look forward to sharing this information with you.</h1>
                    <p>Note: Please note that email messages are not sent in an encrypted or otherwise secured format. You can stop receiving these messages at any time by using the unsubscribe link in any of the messages you receive.</p>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center maxWidth-content">
                    <a className="btn btn-primary" href="#" onClick={this.handleLeavePage}>GOT IT</a>
                </div>
            </div>
        </div>
        const successOptOut = <div className="col-12">
            <div className="row">
                <div className="col-12 text-center maxWidth-content">
                    <h1 className="page-heading">Thank you for your response.</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center maxWidth-content">
                    <a className="btn btn-primary" href="#" onClick={this.handleLeavePage}>CONTINUE</a>
                </div>
            </div>
        </div>
        const failure = <div className="col-12">
            <div className="row">
                <div className="col-12 text-center maxWidth-content">
                    <h1 className="page-heading">Unable to update your preference at this time.</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center maxWidth-content">
                    <a className="btn btn-primary" href="#" onClick={this.handleLeavePage}>OKAY</a>
                </div>
            </div>
        </div>
        const renderElement = () => {
            if (!marketingEmailOptIn.waiting && marketingEmailOptIn.success && this.state.optIn) {
                return successOptIn
            } else if (!marketingEmailOptIn.waiting && marketingEmailOptIn.success && !this.state.optIn) {
                return successOptOut
            } else if (!marketingEmailOptIn.waiting && !marketingEmailOptIn.success && this.state.optIn !== null) {
                return failure
            } else {
                return promptOptIn
            }
        }

        return (
            <div className="container-fluid  marketing-opt-in-container">
                <div className="row">
                    <div className="col-12   maxWidth-content text-center">
                        <img alt="MyBSWHealth" src="/images/mybswlogo.svg" className="img-fluid" />
                        <div className="step-heading-icon"><span className="svg-messages" /></div>
                    </div>
                </div>
                <div className="row marketing-opt-in__body">
                    {renderElement()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        firstName: state.sso.userDetails?.Givenname,
        lastName: state.sso.userDetails?.Surname,
        email: state.sso.userDetails?.Email,
        marketingEmailOptIn: state.marketingEmailOptIn,
        showInsuranceForm: state.session.showInsuranceForm,
        exitToPath: state.session.serverData.marketingEmailExitToPath
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMarketingEmailOptIn: (optInData) => {
            dispatch({
                type: SET_MARKETING_EMAIL_OPT_IN,
                data: optInData
            })
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketingEmailOptIn);